export default __webpack_public_path__ + "static/media/Streets.5f3a665b.png";